/**
 * Sticky add to cart bar
 *
 * Deliberately does NOT re-implement adding to cart. It mirrors the real
 * add-to-cart button's state and forwards taps to it, so the theme's own
 * handler runs against the real form — keeping variant selection, quantity /
 * bundle pricing, line-item properties and the ajax drawer all intact.
 */
(function() {
  'use strict';

  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  var section = document.querySelector('[data-section-type="product"]');
  var realBtn = section ? section.querySelector('.ProductForm__AddToCart') : null;
  var buyButtons = section ? section.querySelector('.ProductForm__BuyButtons') : null;

  if (!realBtn || !buyButtons) {
    if (bar.parentNode) bar.parentNode.removeChild(bar);
    return;
  }

  var stickyBtn = bar.querySelector('[data-sticky-add]');
  var stickyPrice = bar.querySelector('[data-sticky-price]');
  var priceList = section.querySelector('.ProductMeta__PriceList');
  // Rendered by Liquid — reading it off the button would cache "Sold Out"
  // on a product that happens to load out of stock.
  var addLabel = stickyBtn.getAttribute('data-add-label') || stickyBtn.textContent.trim();

  // === MIRROR THE REAL BUTTON ===

  // theme.js strips data-action when a variant genuinely can't be bought, but
  // while an add is in flight it only sets `disabled`. That difference is how
  // we avoid flashing "sold out" styling during a normal add.
  function isUnavailable() {
    return realBtn.hasAttribute('disabled') && !realBtn.hasAttribute('data-action');
  }

  // === SIZE FIRST (31 Oct 2026) ===
  // The theme pre-selects the first size, so a bar that shows before she has reached the
  // sizes could add one she never chose. Until she picks (or arrives on ?variant=), the bar
  // reads "Select size" and a tap takes her to the sizes; after that it adds in one tap.
  var options = section.querySelectorAll('.ProductForm__Option');
  var firstOption = options.length ? options[0] : null;
  var chosen = !firstOption || /[?&]variant=/.test(location.search) ||
    section.querySelectorAll('.ProductForm__Option input[type="radio"]').length <= 1;
  var chooseLabel = stickyBtn.getAttribute('data-choose-label') || 'Select size';

  section.addEventListener('change', function(e) {
    if (e.target.closest && e.target.closest('.ProductForm__Option')) { chosen = true; syncButton(); }
  });
  section.addEventListener('click', function(e) {
    if (e.target.closest && e.target.closest('.ProductForm__Option label, .ProductForm__Option .SizeSwatch, .VirtualSize [data-virtual-size]')) {
      setTimeout(function() { chosen = true; syncButton(); }, 0);
    }
  });

  function goToSizes() {
    var top = firstOption.getBoundingClientRect().top + window.pageYOffset;
    var header = document.querySelector('.Header__Wrapper');
    var pinned = header && getComputedStyle(header.closest('#shopify-section-header') || header).position === 'sticky' ? header.offsetHeight : 0;
    window.scrollTo({ top: Math.max(0, top - pinned - 24), behavior: 'smooth' });
    firstOption.classList.remove('is-nudged');
    void firstOption.offsetWidth;
    firstOption.classList.add('is-nudged');
  }

  function syncButton() {
    var unavailable = isUnavailable();
    stickyBtn.disabled = realBtn.hasAttribute('disabled');
    stickyBtn.classList.toggle('is-unavailable', unavailable);
    stickyBtn.classList.toggle('is-choose', !unavailable && !chosen);
    stickyBtn.textContent = unavailable ? (realBtn.textContent.trim() || addLabel) : (chosen ? addLabel : chooseLabel);
  }

  function syncPrice() {
    if (stickyPrice && priceList) stickyPrice.innerHTML = priceList.innerHTML;
  }

  new MutationObserver(syncButton).observe(realBtn, {
    attributes: true,
    attributeFilter: ['disabled', 'data-action', 'class'],
    childList: true,
    characterData: true,
    subtree: true
  });

  if (priceList) {
    new MutationObserver(syncPrice).observe(priceList, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  syncButton();
  syncPrice();

  // === FORWARD THE TAP ===
  stickyBtn.addEventListener('click', function(e) {
    e.preventDefault();
    if (stickyBtn.disabled) return;
    if (!chosen && !isUnavailable()) { goToSizes(); return; }
    realBtn.click();
  });

  // === SHOW ONLY AFTER THE REAL BUTTON HAS SCROLLED AWAY ===

  // Publish the bar's real height so the chat widget can be lifted clear of it
  // (see the StickyAtc--visible rules in custom.css). Measured rather than
  // hard-coded because the bar grows on a sale price or a long title.
  function publishHeight() {
    var h = bar.offsetHeight;
    if (h) document.documentElement.style.setProperty('--sticky-atc-height', h + 'px');
  }

  // === KEEP THE CHAT WIDGET CLEAR OF THE BAR ===
  // The chat bubble is injected by an app after page load, and its markup has
  // changed between versions, so matching on a selector is unreliable. Instead
  // find whatever is actually pinned to the bottom of the screen next to our
  // bar and lift it, remembering the original value so it can be put back.
  var lifted = [];

  function findBottomPinnedWidgets() {
    var found = [];
    var children = document.body.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el === bar || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') continue;
      if (el.hasAttribute('data-sticky-atc')) continue;

      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed') continue;

      var bottom = parseFloat(cs.bottom);
      if (isNaN(bottom) || bottom > 140) continue;      // not sitting at the bottom
      var rect = el.getBoundingClientRect();
      if (!rect.width || !rect.height) continue;         // not actually visible
      if (rect.width > window.innerWidth * 0.9) continue; // a full-width overlay, not a bubble

      found.push({ el: el, original: el.style.bottom });
    }
    return found;
  }

  function liftWidgets() {
    if (window.innerWidth >= 1008) return;
    if (lifted.length) return;
    lifted = findBottomPinnedWidgets();
    // The sticky cart bar stacks above this one, so a chat bubble has to clear
    // both. Measured rather than assumed — the cart bar is not always present
    // (it hides on an empty bag) and is absent entirely on the cart page.
    var cartBar = document.querySelector('[data-sticky-cart].is-visible');
    var stack = (bar.offsetHeight || 64) + (cartBar ? cartBar.offsetHeight : 0);
    var offset = stack + 14;
    lifted.forEach(function(item) {
      item.el.style.setProperty('bottom', offset + 'px', 'important');
    });
  }

  function dropWidgets() {
    lifted.forEach(function(item) {
      if (item.original) item.el.style.setProperty('bottom', item.original);
      else item.el.style.removeProperty('bottom');
    });
    lifted = [];
  }

  function setVisible(on) {
    bar.classList.toggle('is-visible', on);
    document.body.classList.toggle('StickyAtc--visible', on);
    if (on) {
      publishHeight();
      liftWidgets();
      // The chat app often mounts late; re-check once it has had time to appear.
      setTimeout(function() { if (bar.classList.contains('is-visible')) { dropWidgets(); liftWidgets(); } }, 1200);
    } else {
      dropWidgets();
    }
  }

  window.addEventListener('resize', function() {
    if (bar.classList.contains('is-visible')) publishHeight();
  }, { passive: true });

  // === SHOW WHENEVER THE REAL BUTTON IS OFF SCREEN (31 Oct 2026) ===
  // Above it or below it, once she has started scrolling: before, the bar only showed after
  // she had passed the button, so scrolling back up or browsing the photos had none.
  var buttonInView = true;
  function update() {
    setVisible(!buttonInView && window.pageYOffset > 120);
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) {
      buttonInView = entries[0].isIntersecting;
      update();
    }, { threshold: 0 }).observe(buyButtons);
  } else {
    buttonInView = false;
  }
  window.addEventListener('scroll', function() {
    if (!('IntersectionObserver' in window)) {
      var r = buyButtons.getBoundingClientRect();
      buttonInView = r.bottom > 0 && r.top < window.innerHeight;
    }
    update();
  }, { passive: true });
})();
